/*
 * @Author: Gavin Chan
 * @Date: 2021-07-24 10:30:37
 * @LastEditors : Please set LastEditors
 * @LastEditTime: 2025-09-22 15:21:23
 * @FilePath     : \examinee_web\src\http\api\information.ts
 * @Descriptions: todo
 */
import axios from "@/utils/request";
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import type { InformationItem, SupplementaryChildrenDictionaryData } from "../interfaceModel/information";
import { emptyGuid } from "@/utils/const";

const TemplateItem = `${ServiceGateWay.REGISTEREDUSER}/ExamineeUserTemplateItemInfo`;
const FILEDINFO = `${ServiceGateWay.FILEDINFO}`;
const REGISTERED = `${ServiceGateWay.REGISTEREDUSER}`;
const DOCUMENTAPI = `${ServiceGateWay.DOCUMENT}/examinee`;
const DICTIONARY = `${ServiceGateWay.DICTIONARY}`;

const TemplateItemInfo = {
  GET: {
    // 考生端 根据Id获取个人模板
    getUserTemplateItem: (id: any, tenantId: string) => {
      return axios({
        url: `${FILEDINFO}/examinee/userTemplateItem/${id}`,
        method: RequestEnum.GET,
        options: { noTransform: true, tenantId },
      });
    },
    // 考生端 获取默认模板
    getUserTemplateItemDefault: (tenantId: string) => {
      return axios({
        url: `${FILEDINFO}/examinee/userTemplateItem/Default`,
        method: RequestEnum.GET,
        options: {
          tenantId,
        },
      });
    },
    //考生端 个人信息页面：获取指定用户的信息项列表(个人信息界面使用)
    getPersonalInformation(cardId: any, tenantId: string) {
      return axios({
        url: `${ServiceGateWay.ZhuoFan_Wb_InformationItemService_WebApi}/api/ExamineeUserTemplateItemInfo/PersonalInformation/${cardId}`,
        method: RequestEnum.GET,
        options: {
          tenantId,
        },
      });
    },
    //考生端 考试报名页面：获取指定用户的信息项列表(个人信息界面使用)
    ExGetInformation: (cardId: any, tenantId: string) => {
      return axios({
        url: `${ServiceGateWay.ZhuoFan_Wb_InformationItemService_WebApi}/api/ExamineeUserTemplateItemInfo/${cardId}`,
        method: RequestEnum.GET,
        options: {
          tenantId,
        },
      });
    },
    // 考试端 通过身份证获取指定的信息项列表(value)信息项专用
    getTemplateItemInfo: (cardId: any, tenantId: string) => {
      return axios<InformationItem[]>({
        url: `${ServiceGateWay.ZhuoFan_Wb_InformationItemService_WebApi}/api/ExamineeUserTemplateItemInfo/${cardId}`,
        method: RequestEnum.GET,
        options: {
          tenantId,
        },
      });
    },
    //考生端 根据id和名称补充树形直接子集字典数据
    SupplementaryChildren: (id: any, name: any, tenantId: string) => {
      return axios<SupplementaryChildrenDictionaryData[]>({
        url: `${DICTIONARY}/ExamineeDictionaries/SupplementaryChildrenDictionaryData/${id}/${name}/SupplementaryChildren`,
        method: RequestEnum.GET,
        options: {
          tenantId,
        },
      });
    },
  },
  POST: {
    // 考试端 通过用户信息项保存的值中的字典id补充字典的名称
    SupplementaryDictionaryName: (data: any, tenantId) => {
      return axios<InformationItem[]>({
        url: `${DICTIONARY}/ExamineeDictionaries/SupplementaryDictionaryName/SupplementaryDictionaryName`,
        method: RequestEnum.POST,
        data,
        options: {
          tenantId,
        },
      });
    },
  },
  PUT: {
    // 考试端 个人信息页面：保存指定用户信息项值
    save: (data: any, tenantId: string) => {
      return axios({
        url: `${ServiceGateWay.ZhuoFan_Wb_InformationItemService_WebApi}/api/ExamineeUserTemplateItemInfo/${emptyGuid}/NewSave`,
        method: RequestEnum.PUT,
        data,
        options: { noTransform: true, tenantId },
      });
    },
    // 考试端 考试报名页面：保存指定用户信息项值
    ExSave: (examineeId: string, data: any, tenantId: string) => {
      return axios({
        url: `${ServiceGateWay.ZhuoFan_Wb_InformationItemService_WebApi}/api/ExamineeUserTemplateItemInfo/${examineeId}/NewSave`,
        method: RequestEnum.PUT,
        data,
        options: { noTransform: true, tenantId },
      });
    },
  },
};

export default { TemplateItemInfo };
